import type { ThemeName } from '@oneaudi/unified-web-alpha-common/dist/cjs/components/theme-provider/theme';

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return { '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*' };
  }
  return { '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*' };
};

export const getThemeName = (defaultThemeName?: ThemeName): ThemeName => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName || 'light';
  }
  return 'dark';
};
